import React, { useState } from "react";
import { motion, AnimatePresence } from 'framer-motion'
import img from "../../plateform/assets/Illustrations/findintelescope.png"
import Input from "../Form/Input";
import TextAreaEditor from "../Form/TextAreaEditor";
import ButtonBlack from "../Buttons/ButtonBlack";
import ImageWithFallback from "../../plateform/components/ImageWithFallback";
import { PATH_END_POINT } from "../../../api";
import { useSelector } from "react-redux";
import { useOutletContext } from "react-router-dom";
import { API_END_POINT } from "../../utils/constant";
import axios from "axios";

const SendEmailModal = ({receiverImage, receiverEmail= "zoenirinamarieviviane@gmail.com", children, styleContent, styleOverlay, isOpen, onClose, initialOverlay, animateOverlay, exitOverlay, initialContent, animateContent, exitContent, width= "90vw", defaultClassName="relative h-fit bg-white rounded-md  max-md:w-[70vw] max-lg:w-[60vw] z-40 lg:w-[50vw]" }) => {
    const {user} = useSelector(store=>store.user)
  const [loading, setLoading] = useState(false);
      const [formData, setFormData] = useState({
        email: receiverEmail,
        subject: "",
        message: "",
      })
    const {showNotif, setShowNotif} = useOutletContext()

const sendEmail = async ()=>{
    setLoading(true)
        const response = await axios.post(`${API_END_POINT}/contact`, formData)
          .then((response)=>{
             console.log("verfication déclenché",  response.data)
             setFormData({ email: "", subject: "", message: "" });
             setShowNotif({ ...showNotif, variant: "success", message: response?.data?.message, show: true });
        //   if (!response.data?.isUnique) {
        //     // setErrors({
        //     //   ...errors,
        //     //   email: "Cet email est déjà utilisé.",
        //     // });
        //   }
        setLoading(false);
          }).catch ((error) =>{
            setLoading(false)
            setShowNotif({ ...showNotif, variant: "danger", message: "Une erreur est survenue", show: true });
          console.error("Erreur lors de la vérification de l'email :", error);
        })
}
    return (
        <>
            <AnimatePresence>
                {
                    isOpen && (
                        <motion.div
                            // onClick={onClose}
                            initial={(initialOverlay === undefined) ? { opacity: 0 } : initialOverlay}
                            animate={(animateOverlay === undefined) ? { opacity: 1 } : animateOverlay}
                            exit={(exitOverlay === undefined) ? { opacity: 0 } : exitOverlay}
                            className={` w-screen h-screen overflow-scroll flex justify-center py-10   fixed z-50 top-0 right-0 bg-slate-700 bg-opacity-40 `}
                        >
                            <motion.div
                                initial={(initialContent === undefined) ? { opacity: 0, translateY: -50 } : initialContent}
                                animate={(animateContent === undefined) ? { opacity: 1, translateY: 0 } : animateContent}
                                exit={(exitContent === undefined) ? { opacity: 0, translateY: -50 } : exitContent}
                                className={defaultClassName}
                            >
                            <div className="p-6">
                                <div className="flex justify-between items-start gap-6">
                                    <div className="text-start">
                                        <h3 className="font-semibold text-lg">Envoyer un email</h3>
                                        <p className="text-primary-text text-sm ">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda sed, eligendi excepturi.</p>
                                    </div>   
                                    <img src={img} alt="image 10"className="w-28" />
                                    
                                </div>
                                <div className="flex flex-col w-full divide-y border-b mb-4 text-sm">
                                    <div className="grid items-center grid-cols-12 gap-x-1 w-full mb-2">
                                        <span className="col-span-1 text-start">De</span>
                                        <div className="full flex items-center gap-2 ">
                                            <ImageWithFallback  src={PATH_END_POINT + user?.photo} className="size-9 rounded-full border" />
                                            {user?.email}
                                        </div>
                                    </div>
                                    <div className="grid items-center grid-cols-12 gap-x-1 w-full py-2">
                                        <span className="col-span-1 text-start">A</span>
                                        {/* <Input type="email" classContainer="col-span-11" className="w-full"></Input> */}
                                        <div className="w-full flex items-center gap-2">
                                            <ImageWithFallback defaultType="user" src={PATH_END_POINT + receiverImage} className="size-9 rounded-full border" />
                                            {receiverEmail || <span className="w-full text-nowrap text-sm">Non Mentionnée</span> }
                                        </div>
                                    </div>

                                    <div className="grid items-center grid-cols-12 gap-x-1 w-full py-2">
                                        <span className="col-span-1 text-start">Objet</span>
                                        <input type="text" className="outline-none border-none p-2 font-normal col-span-11" placeholder="Saisir l'objet..." value={formData.subject} onChange={(e)=> setFormData({ ...formData, subject: e.target.value })} />                                        
                                    </div>
                                </div>
                                <TextAreaEditor name="message" value={formData.message}  setValue={(value)=>setFormData({...formData, message: value})} />
                            </div>
                            <div className="flex rounded-b-md items-center justify-between bg-gray-50 py-3 px-6">
                                {/* <ButtonBlack onClick={sendEmail}>Envoyer</ButtonBlack> */}
                                <button 
                                    onClick={()=>onClose()}
                                    className='px-6 py-2 rounded-md border text-primary-black'>
                                    Annuler
                                </button>
                                <ButtonBlack type="submit" isLoading={loading} onClick={sendEmail}>
                                    Envoyer
                                </ButtonBlack>                              
                            </div>

                            </motion.div>

                        </motion.div>
                    )
                }
            </AnimatePresence>
        </>
    )
}

export default SendEmailModal